<template>

 <footer class="text-white">
    <div class="container">
        <br>
        <div class="col-lg-12 copyright">
            <div class="row d-flex">
                <p class="col-md-8">2022. Kallpa Securities Sociedad Agente de Bolsa / Kallpa Cambios. Todos los derechos reservados. </p>
               <p class="col-md-2"><a :href="urlPoliticasSeguridad" target="_blank" class="poli-term">Políticas de privacidad</a></p>
                <p class="col-md-2"><a :href="urlTerminosCondiciones" target="_blank" class="poli-term">Términos y condiciones</a></p>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
import auth from '@/services/auth'

export default {
  name: "Footer",
  data() {
    return {
      urlPoliticasSeguridad: "#",
      urlTerminosCondiciones: "#",
    };
  },
  mounted(){
    auth.listParameters().then(response => {
      this.urlTerminosCondiciones = response.ParametrosGenerales.find(e=>e.Id == "MENS0006").DetalleParametroValor;
      this.urlPoliticasSeguridad = response.ParametrosGenerales.find(e=>e.Id == "MENS0007").DetalleParametroValor;
    });


    
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/Footer.vue